import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const linksVariants = {
	hover: {
		backgroundColor: 'rgb(184, 46, 46)',
		textShadow: '0px 0px 8px rgb(255, 255, 255)',
		boxShadow: '0px 0px 8px rgb(255, 255, 255)',
		transition: {
			duration: 0.3,
		},
	},
};

function Projects({ projects, root }) {
	return (
		<div id="projects" className="max-w-screen-2xl h-fit m-auto mt-36">
			<div className="w-11/12 mx-auto flex flex-col justify-center items-center gap-4">
				<h2 className="text-2xl xs:text-3xl sm:text-5xl font-bold">Projects</h2>
				<p className="font-medium text-center">
					Check out some of my projects down below!
				</p>
			</div>

			<div className="w-11/12 mx-auto mt-20 mb-10 flex flex-wrap justify-evenly gap-9">
				{projects.map(
					({ image, title, description, tags, sourceCode, visit, id }) => (
						<motion.div
							initial={{ opacity: 0 }}
							whileInView={{
								opacity: 1,
								transition: { duration: 1.5, ease: 'easeOut' },
							}}
							viewport={{ once: true }}
							key={id}
							className="w-full xs:w-[380px] h-fit rounded-xl bg-light-naive shadow-[0px_0px_7px_hsl(204,23.8%,95.9%,.7)]"
						>
							<div className="w-full h-[300px]">
								<img
									className="w-full h-full object-fill rounded-tl-xl rounded-tr-xl"
									src={image}
									alt="site interface"
								/>
							</div>
							<div className="w-full h-fit xs:h-[300px] mx-auto my-3 flex flex-col justify-between">
								<div className="w-11/12 h-fit xs:h-[55%] mx-auto flex flex-col items-center">
									<p className="mb-3 font-medium text-center text-lg sm:text-xl tracking-[2px]">
										{title}
									</p>
									<p className="text-justify">{description}</p>
								</div>
								<div className="w-11/12 h-fit xs:h-[30%] mx-auto my-3 xs:my-0 flex flex-col items-center">
									<p className="font-semibold text-lg sm:text-xl mb-3">Stack</p>
									<p className=" text-gray">{tags.join(',   ')}.</p>
								</div>
								<div className="w-11/12 h-fit xs:h-[15%] mx-auto flex flex-row justify-between items-center">
									<motion.a
										variants={linksVariants}
										whileHover="hover"
										href={sourceCode}
										target="blank"
										className="w-[65px] h-[30px] no-underline flex flex-col justify-center items-center rounded-lg bg-light-red"
									>
										Code
									</motion.a>
									<motion.a
										variants={linksVariants}
										whileHover="hover"
										href={visit}
										target="blank"
										className="w-[65px] h-[30px] no-underline flex flex-col justify-center items-center rounded-lg bg-light-red"
									>
										Site
									</motion.a>
								</div>
							</div>
						</motion.div>
					)
				)}
			</div>
			{root && (
				<Link
					to="/projects"
					className="w-11/12 mx-auto mb-20 flex flex-col justify-center items-center no-underline"
				>
					<motion.button
						whileHover={{
							scale: 1.02,
							backgroundColor: 'rgb(184, 46, 46)',
							textShadow: '0px 0px 8px rgb(255, 255, 255)',
							boxShadow: '0px 0px 8px rgb(255, 255, 255)',
							transition: { duration: 0.3, repeat: Infinity },
						}}
						className="w-full xs:w-[380px] h-[40px] xs:h-[45px] flex flex-col justify-center items-center rounded-lg bg-light-red text-lg xs:text-xl"
					>
						View All...
					</motion.button>
				</Link>
			)}
		</div>
	);
}

export default Projects;
